// src/api/axios.js

import axios from 'axios';

const api = axios.create({
  baseURL: 'https://adm1n.bti.com.np/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;